module.exports = __webpack_public_path__ + "img/2.328ab041.png";